module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/whiteSpinner.b1e4af0f.svg";